import { CommonOption } from '../types/common.types';

/**
 * Returns a new array of options sorted A-Z by label (case-insensitive, numeric-aware).
 * Does not mutate the input array.
 */
export const sortOptionsByLabel = <T extends Pick<CommonOption, 'label'>>(options: T[]): T[] => {
	return [...options].sort((a, b) =>
		a.label.localeCompare(b.label, undefined, { sensitivity: 'base', numeric: true })
	);
};
